<script>
export default {
  name: "introduction",
  props: {
    text: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      // 是否展开
      isShow: false,
      isLoading: true,
    }
  },
  methods: {}
}
</script>

<template>
  <div class="introduction">
    <div class="title">概述：</div>
    <div class="content">
      <div
          v-if="text.remark"
          class="content-body"
          :class="{
            'content-open': isShow,
            'content-hidden': !isShow,
            'isAuto': text.remark?.length < 590,
          }"
      >
        <div v-html="text.remark"></div>
      </div>
      <div v-else style="color: #999999">暂无内容</div>
      <div class="myBtn" v-if="text.remark?.length>590" @click="isShow = !isShow">
        {{ isShow ? '收回概述' : '展开更多' }}
        <span v-if="isShow" class="fa fa-angle-up"></span>
        <span v-else class="fa fa-angle-down"></span>
      </div>
    </div>
    <!--    <el-empty v-else description="暂无数据"></el-empty>-->
  </div>
</template>

<style scoped lang="scss">
.introduction {
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 20px 20px 40px;

  .title {
    font-weight: 700;
    padding-bottom: 10px;
    position: relative;
    padding-left: 15px;
    font-size: 18px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 4px;
      height: 16px;
      width: 4px;
      background-color: #eb5412;
      border-radius: 3px;
    }
  }

  .content {
    display: flex;
    gap: 16px;
    position: relative;

    .content-body {
      flex: 1;
      font-size: 14px;
      color: #666;
      line-height: 1.5em;
      transition: 300ms ease;
      overflow: hidden;
      display: grid;
      grid-template-rows: 0fr;

      & * {
        min-height: 23rem;
      }

      &.content-open {
        grid-template-rows:  1fr;
      }

      &.content-hidden {
        min-height: 23rem;
        //display: -webkit-box;
        //-webkit-box-orient: vertical;
        //-webkit-line-clamp: 3; /* 设置显示的行数 */
        //text-overflow: ellipsis;
      }

      &.isAuto {
        min-height: auto;

        & * {
          min-height: auto;
        }
      }
    }

    .myBtn {
      align-content: end;
      color: var(--swiper-theme-color);
      cursor: pointer;
      user-select: none;
      position: absolute;
      right: 0;
      bottom: 0;
      transform: translateY(100%);
    }
  }
}
</style>